<template>
  <div id="home">
    <!-- section2 -->
    <v-container class="section" grid-list-md text-xs-center>
      <v-layout class="text-xs-left" row wrap>
        <v-flex xs6 md6 lg6>
          <v-hover>
            <v-card slot-scope="{ hover }" class="mx-auto wow slideInLeft" color="grey lighten-4" max-height="600" to="/hotel">
              <v-img :src="require('../../public/images/home/1_11.jpg')" :aspect-ratio="1.7">
                <v-expand-transition>
                  <div v-if="hover" class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text" style="height: 100%;">
                    <v-container fill-height fluid>
                      <v-layout fill-height>
                        <v-flex xs12 align-end flexbox>
                          <div class="headline">海外资产配置</div>
                          <div class="subheading">美元进入加息周期，境内投资风险逐步聚集，全球资产配置时代来临。</div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </div>
                </v-expand-transition>
              </v-img>
            </v-card>
          </v-hover>
        </v-flex>
        <v-flex xs6 md6 lg6>
          <v-hover>
            <v-card slot-scope="{ hover }" class="mx-auto wow slideInRight" color="grey lighten-4" max-height="600" to="/fund">
              <v-img :src="require('../../public/images/home/1_12.jpg')" :aspect-ratio="1.7">
                <v-expand-transition>
                  <div v-if="hover" class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text" style="height: 100%;">
                    <v-container fill-height fluid>
                      <v-layout fill-height>
                        <v-flex xs12 align-end flexbox>
                          <div class="headline">海外资产运营</div>
                          <div class="subheading">布局全球热点旅游城市，打造两大精品住宿系列</div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </div>
                </v-expand-transition>
              </v-img>
            </v-card>
          </v-hover>
        </v-flex>
        <v-flex xs6 md4 lg4>
          <v-hover>
            <v-card slot-scope="{ hover }" class="mx-auto wow slideInUp" color="grey lighten-4" to="/travel">
              <v-img :src="require('../../public/images/home/1_13.jpg')" :aspect-ratio="16/9">
                <v-expand-transition>
                  <div v-if="hover" class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text" style="height: 100%;">
                    <v-container fill-height fluid>
                      <v-layout fill-height>
                        <v-flex xs12 align-end flexbox>
                          <div class="headline">海外生活体验</div>
                          <div class="subheading">慢生活享受式度假</div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </div>
                </v-expand-transition>
              </v-img>
            </v-card>
          </v-hover>
        </v-flex>
        <v-flex xs6 md4 lg4>
          <v-hover>
            <v-card slot-scope="{ hover }" class="mx-auto wow slideInUp" color="grey lighten-4">
              <a href="https://www.jianguoyun.com/p/DdMM3PMQuc7nBxjWvPwB" target="_blank">
                <v-img :src="require('../../public/images/home/1_14.jpg')" :aspect-ratio="16/9">
                  <v-expand-transition>
                    <div v-if="hover" class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text" style="height: 100%;">
                      <v-container fill-height fluid>
                        <v-layout fill-height>
                          <v-flex xs12 align-end flexbox>
                            <div class="headline">基金公告</div>
                            <div class="subheading">点击查看详情>>></div>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </div>
                  </v-expand-transition>
                </v-img>
              </a>
            </v-card>
          </v-hover>
        </v-flex>
        <v-flex xs6 md4 lg4>
          <v-hover>
            <v-card slot-scope="{ hover }" class="mx-auto wow slideInUp" color="grey lighten-4" to="/about">
              <v-img :src="require('../../public/images/home/1_15.jpg')" :aspect-ratio="16/9">
                <v-expand-transition>
                  <div v-if="hover" class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text" style="height: 100%;">
                    <v-container fill-height fluid>
                      <v-layout fill-height>
                        <v-flex xs12 align-end flexbox>
                          <div class="headline">关于</div>
                          <div class="subheading">迦南资本是专注于资产全球化配置与运营和深度海外生活体验</div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </div>
                </v-expand-transition>
              </v-img>
            </v-card>
          </v-hover>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- section3 -->
    <div class="section">
      <v-layout class="text-xs-left" row wrap transition="slide-y-transition">
        <v-flex xs12 md9 lg-9>
          <v-card class="wow slideInLeft">
            <v-img class="white--text" height="450px" :src="require('../../public/images/home/1_21.jpg')">
              <v-container fill-height fluid>
                <v-layout fill-height align-center>
                  <v-flex xs1 md1 lg1></v-flex>
                  <v-flex xs12 md7 lg7>
                    <div class="subheading mb-3">迦南资本致力于为社会公益事业奉献自己的力量。公司控股股东李晓东先生在汶川地震时亲自带领团队入住灾区，为重建募集资金，与灾区同胞同甘共苦。</div>
                    <div class="subheading mb-3">多年来，迦南人不忘初心，始终秉持无私、无畏的精神致力于社会公益事业，力所能及地奉献爱心。</div>
                    <div class="subheading mb-3">从四川什邡灾后重建让特殊孩子和残疾人士都能接受现代化教育，捐助了什邡市特殊教育学校的校舍建设，后续也长期资助及支持学校各方面活动开展。</div>
                  </v-flex>
                  <v-flex xs3 md3 lg5 text-xs-center>
                    <div class="display-1">公益与回馈</div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout class="text-xs-left" row wrap justify-end style="margin-top: 20px">
        <v-flex xs12 md9 lg-9>
          <v-card class="wow slideInRight">
            <v-img class="white--text" height="450px" :src="require('../../public/images/home/1_22.jpg')">
              <v-container fill-height fluid>
                <v-layout fill-height align-center>
                  <v-flex xs3 md5 lg5 text-xs-center>
                    <div class="display-1">荣誉</div>
                  </v-flex>
                  <v-flex xs12 md7 lg7>
                    <div class="subheading mb-4">迦南资本是首批注册于上海自贸区的资产管理公司，并在中国证券基金业协会备案，成为开展股权投资、创业投资等私募基金业务的金融机构，在第四届全球房地产金融峰会中获“2015年度最佳创新实践海外基金公司”。</div>
                  </v-flex>
                  <v-flex xs1 md1 lg1></v-flex>
                </v-layout>
              </v-container>
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { WOW } from 'wowjs'

export default {
  data() {
    return {}
  },
  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      var wow = new WOW({
        live: false
      })
      wow.init()
    })
  }
}
</script>

<style lang="scss" scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
